import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KeepFilterService {
  public title = '';
  public status = '';
  public assessmentCoordinator = '';
  public legalUnit = '';
  public audit = '';
  public plant = '';
  public category = '';

  public auditTitle = '';
  public audit_status = '';
  public audit_assessmentCoordinator = '';
  public audit_legalUnit = '';
  public bg = '';
  public reportYear = '';
}
